import { action, computed, makeObservable, observable } from 'mobx';

export interface AuthState {
  token: string;
  expiresAt: number;
}

/** PRR-316: the tenant admin role — mirrors the backend's AppRoles.Admin ('ADMIN'). Nav visibility is UX only; every endpoint independently enforces this role server-side. */
export const ADMIN_ROLE = 'ADMIN';

class UserStore {
  token: string | null = null;
  expiresAt: number | null = null;
  isInitialising = true;
  roles: string[] = [];

  constructor() {
    makeObservable(this, {
      token: observable,
      expiresAt: observable,
      isInitialising: observable,
      roles: observable,
      isAuthenticated: computed,
      isAdmin: computed,
      setAuth: action,
      clearAuth: action,
      setInitialising: action,
      setRoles: action,
    });
  }

  get isAuthenticated(): boolean {
    return Boolean(this.token);
  }

  get isAdmin(): boolean {
    return this.roles.includes(ADMIN_ROLE);
  }

  setAuth({ token, expiresAt }: AuthState): void {
    this.token = token;
    this.expiresAt = expiresAt;
  }

  clearAuth(): void {
    this.token = null;
    this.expiresAt = null;
    this.roles = [];
  }

  setInitialising(isInitialising: boolean): void {
    this.isInitialising = isInitialising;
  }

  setRoles(roles: string[]): void {
    this.roles = roles;
  }
}

export const userStore = new UserStore();
